import {datePickerLocale} from "../../../../common/datePickerLocale";

export const datePickerBaseSetting = () => ({
    opens: 'left',
    showCustomRangeLabel: true,
    locale: datePickerLocale(),
})
